import { render, staticRenderFns } from "./DowntimeChart.vue?vue&type=template&id=21a8d97c&"
import script from "./DowntimeChart.vue?vue&type=script&lang=js&"
export * from "./DowntimeChart.vue?vue&type=script&lang=js&"
import style0 from "./DowntimeChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports